import { toast } from 'react-toastify';

const DELIVERY_COORDINATES_ERROR_MESSAGES: Record<string, string> = {
  missing_delivery_coordinates:
    'Impossible d’affecter cette commande à la tournée : les coordonnées de l’adresse de livraison n’ont pas pu être déterminées dans Odoo.',
  delivery_coordinates_lookup_failed:
    'Impossible d’affecter cette commande à la tournée : les coordonnées de livraison n’ont pas pu être vérifiées dans Odoo. Réessayez dans quelques instants.',
};

export const getDeliveryCoordinatesErrorMessage = (
  rejectedQuery: unknown,
): string | undefined => {
  const error = rejectedQuery as {
    error?: { data?: { code?: string } };
    data?: { code?: string };
  };
  const code = error?.error?.data?.code ?? error?.data?.code;
  return code ? DELIVERY_COORDINATES_ERROR_MESSAGES[code] : undefined;
};

export const notifyDeliveryCoordinatesError = async (
  queryFulfilled: Promise<unknown>,
) => {
  try {
    await queryFulfilled;
  } catch (error) {
    const message = getDeliveryCoordinatesErrorMessage(error);
    if (message) toast.error(message);
  }
};
